import React, { useContext, useEffect, useState } from 'react'
import Button from '../components/button'
import Top from '../components/top'
import Table from '../components/table'
import { useNavigate } from 'react-router-dom'
import { AuthContext } from '../contexts/AuthProvider'
import { DetailsContext } from '../contexts/DetailsContext'

const Countries = (props) => {
    const [showModal, setShowModal] = useState(false);
    const {
      user,
      setUser,
      isLogged,
      setIsLogged,
      login,
      logout
    } = useContext(AuthContext)

    const { countries } = useContext(DetailsContext)
    
    const navigate = useNavigate()
    useEffect(() => {
      if (!isLogged) {
        navigate('/')
      }
    }, [isLogged])

    const inputs = [
        {
          name: "code",
          icon: 'fa-solid fa-user',
          type: 'text',
          placeholder: 'Enter Code',
        },
        {
          name: "name",
          icon: 'fa-solid fa-user',
          type: 'text',
          placeholder: 'Enter Country name'
        },
        {
            name: "currency",
            icon: 'fa-solid fa-user',
            type: 'text',
            placeholder: 'Enter Currency Symbol(Kes)'
          },
          {
            name: "rate",
            icon: 'fa-solid fa-user',
            type: 'text',
            placeholder: 'Enter rate'
          },
          {
            name: "bank",
            icon: 'fa-solid fa-user',
            type: 'number',
            placeholder: 'Enter Bank ID'
          }
      ]

    props.setNavShow(true)
    function formatNumber(number) {
      return number.toLocaleString('en-US', { 
          minimumFractionDigits: 2, 
          maximumFractionDigits: 2 
      });
  }
    const userColumns = ['Country ID', 'Code', 'Name', 'Currency', 'Rate', 'Gateway ID']
    function addUsers(){
        window.location.replace('/edit')
    }
    const link = 'https://xgramm.com/xgramm_backend/admin/countries.php'
  return (
    <div  style={{position: 'relative'}} className='w3-col l9 w3-right m9 s12 main'>
        <Top showModal={showModal} setShowModal={setShowModal} isAdd={true} value='Add New Country' name='Country'/>
        <div className="w3-container">
        <Table tableName='countries' link={link} inputs={inputs} showModal={showModal} setShowModal={setShowModal} name='Countries' columns={userColumns} data={countries ? countries : []} summary={false} edit={true} />
        </div>
    </div>
  )
}

export default Countries